import { DOCUMENT, inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Translation, TranslocoLoader } from "@jsverse/transloco";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly _http = inject(HttpClient);
  private readonly _document = inject(DOCUMENT);

  getTranslation(lang: string) {
    // Resolve against <base href> so JSON loads correctly under any deploy path
    // (and not relative to the current SPA route).
    const url = new URL(
      `assets/i18n/${lang}.json`,
      this._document.baseURI,
    ).toString();
    return this._http.get<Translation>(url);
  }
}
